export interface CalculationHistoryItem {
  id: string;
  calculatorName: string;
  timestamp: number;
  inputs: Record<string, any>;
  outputs: Record<string, any>;
}

const MAX_HISTORY_ITEMS = 10;
const STORAGE_KEY = 'calculator_history';

export const getCalculationHistory = (): CalculationHistoryItem[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading calculation history:', error);
    return [];
  }
};

export const addCalculationToHistory = (
  calculatorName: string,
  inputs: Record<string, any>,
  outputs: Record<string, any>
): void => {
  try {
    const history = getCalculationHistory();
    const newItem: CalculationHistoryItem = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      calculatorName,
      timestamp: Date.now(),
      inputs,
      outputs,
    };

    const updatedHistory = [newItem, ...history].slice(0, MAX_HISTORY_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
  } catch (error) {
    console.error('Error saving calculation to history:', error);
  }
};

export const clearCalculationHistory = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing calculation history:', error);
  }
};

export const removeCalculationFromHistory = (id: string): void => {
  try {
    const history = getCalculationHistory();
    const filtered = history.filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  } catch (error) {
    console.error('Error removing calculation from history:', error);
  }
};
